import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { Stakeholder } from "@wingspanhq/wingspan-api-sdk";
import { StakeholderNameCell } from "../StakeholderCells/StakeholderNameCell";
import { StakeholderStatusCell } from "../StakeholderCells/StakeholderStatusCell";
import { TableItemData } from "./TableStakeholders";

type ColumnsConfig = {
  roleNameById: Map<string | undefined, string | undefined>;
};

export const getColumns = ({
  roleNameById
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      justify: "start",
      header: { text: "Name" },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: ({ data }: { data: Stakeholder }) => (
      <StakeholderNameCell stakeholder={data} />
    )
  },
  {
    config: {
      justify: "start",
      header: { text: "Status" }
    },
    renderFunction: ({ data }: { data: Stakeholder }) => (
      <StakeholderStatusCell stakeholder={data} />
    )
  },
  {
    config: {
      header: { text: "Role" },
      hideOnScreens: ["XS"],
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: ({ data }: { data: Stakeholder }) => (
      <WSTableCell
        text={(data.roleId && roleNameById.get(data.roleId)) || "—"}
      />
    )
  }
];
